import { APIModel } from './api-model.model'

export class APICarrier extends APIModel {
    carrierId: number;
    carrierName: string;
    carrierEnabled: number;
    countryId: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        carrierId: number;
        carrierName: string;
        carrierEnabled: number;
        countryId: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.carrierId = params.carrierId
        this.carrierName = params.carrierName
        this.countryId = params.countryId
        this.carrierEnabled = params.carrierEnabled ? 1 : 0
    }
}
